import { desaturate as _desaturate, mix as _mix, parseToRgb as _parseToRgb, readableColor, rgbToColorString, toColorString } from "polished";
export function toColorMatrix(color, overrideAlpha) {
    const { red, green, blue, alpha } = parseToRgb(color);
    return `0 0 0 0 ${red / 255} 0 0 0 0 ${green / 255} 0 0 0 0 ${blue / 255} 0 0 0 ${overrideAlpha !== null && overrideAlpha !== void 0 ? overrideAlpha : alpha} 0`;
}
export function parseToRgb(color) {
    if (color === "transparent") {
        color = "#ffffff00";
    }
    return Object.assign({ alpha: 1 }, _parseToRgb(color));
}
export function parseToColorString(color) {
    try {
        return toColorString(parseToRgb(color));
    }
    catch (_a) {
        return color;
    }
}
export function contrast(color, light, dark) {
    return readableColor(color, light, dark);
}
export function desaturate(color, factor) {
    return _desaturate(factor, color);
}
export function fade(color, alpha) {
    const colorRgb = parseToRgb(color);
    return rgbToColorString(Object.assign(Object.assign({}, colorRgb), { alpha }));
}
export function mix(color, mixColor, factor) {
    return _mix(1 - factor, color, mixColor);
}
export function shade(color, factor) {
    return mix(color, "#000000", factor);
}
export function tint(color, factor) {
    return mix(color, "#ffffff", factor);
}
//# sourceMappingURL=color.js.map